var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"asset-title"},[_c('div',{staticClass:"ellipse wrn-m-r-05",class:_vm.computedClass}),_c('p',{staticClass:"asset-title__label"},[_vm._v(_vm._s(_vm.computedAssetName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }